import { render, staticRenderFns } from "./StatusSetting.vue?vue&type=template&id=e2d77b06"
import script from "./StatusSetting.vue?vue&type=script&lang=js"
export * from "./StatusSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports